<div class="error-page container py-6">
  <div class="text-primary">My <strong>Fare</strong>Finder</div>

  <div class="row justify-content-center">
    <div class="col-12 col-md-6 col-lg-5">
      <h3 class="font-weight-normal mb-4">{{ title }}</h3>

      <p class="text-muted mb-4">{{ errMessage || message }}</p>

      <p class="text-danger mb-4">{{ 'ERROR_PAGES.ERROR_CODE' | translate }} {{ code }}</p>

      <div class="d-flex justify-content-end">
        <button *ngIf="mainPageBtn" type="button" class="btn" (click)="navigateToMainPage()">
          {{ 'GENERAL.TO_MAIN_PAGE' | translate }}
        </button>

        <button *ngIf="backBtn" appNavigateBack type="button" class="btn btn-primary ml-2">{{ 'GENERAL.BACK_BTN' | translate }}</button>

        <button *ngIf="loginPageBtn" type="button" class="btn btn-primary ml-2" (click)="navigateToLoginPage()">
          {{ 'GENERAL.TO_LOGIN_PAGE' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div></div>
</div>
